import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";

function HeaderProfileMenu({ name, surname, onLogout }) {
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);
  const navigate = useNavigate();

  // Dışarı tıklanınca menüyü kapat
  useEffect(() => {
    function handleClickOutside(e) {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div style={{ position: "relative" }} ref={menuRef}>
      {/* Avatar + isim butonu */}
      <button
        onClick={() => setOpen((v) => !v)}
        style={{
          background: "none",
          border: "none",
          display: "flex",
          alignItems: "center",
          gap: "10px",
          cursor: "pointer",
          padding: "6px 10px",
        }}
      >
        <div
          style={{
            width: 36,
            height: 36,
            borderRadius: "50%",
            background: "#1976d2",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: 600,
            fontSize: 14,
          }}
        >
          {name?.[0]}
          {surname?.[0]}
        </div>
        <span style={{ fontWeight: 500, color: "#283049" }}>
          {name} {surname}
        </span>
      </button>

      {/* Dropdown menü */}
      {open && (
        <div
          style={{
            position: "absolute",
            top: "110%",
            right: 0,
            background: "#fff",
            border: "1px solid #e4e8ec",
            borderRadius: 8,
            boxShadow: "0 6px 16px rgba(0,0,0,0.08)",
            minWidth: 190,
            zIndex: 20,
            overflow: "hidden",
          }}
        >
          <div
            style={menuItemStyle}
            onClick={() => {
              navigate("/profile");
              setOpen(false);
            }}
          >
            Profilim
          </div>
          <div
            style={{ ...menuItemStyle, color: "#d32f2f", fontWeight: 600 }}
            onClick={onLogout}
          >
            Çıkış
          </div>
        </div>
      )}
    </div>
  );
}

const menuItemStyle = {
  padding: "12px 16px",
  cursor: "pointer",
  color: "#283049",
  fontWeight: 500,
  fontSize: 14,
  transition: "background 0.2s",
  borderBottom: "1px solid #f4f4f4",
};

export default HeaderProfileMenu;
